<template>
  <div>
    <div
      v-if="
        currentOs && program === 'sam' && new Date().getFullYear() == '2022'
      "
    >
      <b-card
        title="Przejście z SAM® na program SKP® - już aktywne"
        class="title-inline"
      >
        <b-card-text class="newyear">
          <p>
            Przypominamy, że od
            <span class="text-underline"
              >1 stycznia 2023 roku całkowicie zaprzestajemy wsparcia programu
              Samozatrudnienie</span
            >. Aktywnym użytkownikom
            <strong>zapewniamy wsparcie</strong> merytoryczne i techniczne do:
            31.01.2023 (lub 30.04.2023 w przypadku posiadania modułu: Deklaracje
            roczne).
          </p>
          <div class="">
            Zamówienie nowych modułów, dodatków,
            <strong>jest już niemożliwe</strong>. Aby tego dokonać, już
            <strong class="info-text">dziś zmień Twój SAM<sup>®</sup></strong>
            na bogatsze funkcjonalnie SKP<sup>®</sup>.<br />
            Dlaczego WARTO?
            <ul class="list-big">
              <li>
                <img :src="styles.check" alt="check" class="mb-1" />
                <strong>BEZPŁATNIE</strong> otrzymujesz program księgowy SKP<sup
                  >®</sup
                >
                Firma na kolejne lata, z zachowaniem wszystkich modułów i
                dodatków, które posiadałeś w SAM<sup>®</sup>;
              </li>
              <li>
                <img :src="styles.check" alt="check" class="mb-1" />
                <strong>Kontynuujesz księgowanie</strong> swojej firmy na
                dotychczas wprowadzonych do SAM<sup>®</sup> danych;
              </li>
              <li>
                <img :src="styles.check" alt="check" class="mb-1" />
                Wraz z nowym SKP<sup>®</sup>
                <strong>dostajesz automatycznie dostęp</strong> do serwisu
                <strong>Moje Konto SKP<sup>®</sup></strong
                >, gdzie bez problemu złożysz zamówienie na Opiekę Serwisową
                2023, zamówisz kolejne moduły, dokonasz zmian adresowych, jak
                również otrzymasz dostęp do darmowego Kursu Obsługi SKP<sup
                  >®</sup
                >
              </li>
              <li>
                <img :src="styles.check" alt="check" class="mb-1" />
                Przechodząc na SKP<sup>®</sup> jeszcze w 2022 roku, otrzymasz
                dodatkowe 35% RABATU na przedłużenie Opieki Serwisowej 2023 do
                SKP<sup>®</sup>
              </li>
            </ul>
          </div>
          <p class="mt-0">
            <a
              href="https://www.samozatrudnienie.pl/przewodnik-przedsiebiorcy/sam-zmiana-na-skp"
              target="_blank"
              >Czytaj więcej o korzyściach z przejścia na SKP<sup>®</sup> ></a
            >
          </p>
          <p class="font-weight-bold info-text">
            Aby przejść już teraz ma SKP<sup>®</sup> otwórz program SAM<sup
              >®</sup
            >
            , kliknij w okienku komunikatu: „TAK, przenieś mnie do
            SKP<sup>®</sup>”.
          </p>
          <p>
            Więcej informacji:
            <a
              href="https://www.samozatrudnienie.pl/przewodnik-przedsiebiorcy/zmiana-sam-na-skp-2022"
              target="_blank"
              >Jak przebiega zmiana na SKP<sup>®</sup>? Czytaj instrukcję ></a
            >
          </p>
        </b-card-text>
      </b-card>
    </div>
    <div v-else-if="orderNotAvailable">
      <block-order :styles="styles"></block-order>
    </div>
    <div v-else>
      <progress-steps
        v-if="currentStep !== 5"
        order="products"
        :isAccountant="isAccountant"
        :skpCompanyAdd="skpCompanyAdd"
        :skpAccountantAdd="skpAccountantAdd"
      ></progress-steps>
      <div v-if="currentStep === 1">
        <order-products
          :isAccountant="isAccountant"
          :accountantAdd="accountantAdd"
          :skpAdd="skpAdd"
          :skpCompanyAdd="skpCompanyAdd"
          :skpAccountantAdd="skpAccountantAdd"
          :isDiscount656_657="isDiscount656_657"
          :styles="styles"
          v-on:addedproduct="filterCloudOptions"
          v-on:clouddatabyclient="updateCloudDataByClient"
          v-on:cloudNeverHave="UpdateCloudNeverHave"
        ></order-products>
      </div>
      <div v-if="currentStep === 2">
        <order-cloud
          :cloudOptions="filteredCloudOptions"
          :cloudNeverHave="cloudNeverHave"
          :isDiscount622_623="isDiscount622_623"
          :isDiscount656_657="isDiscount656_657"
          :cloudDiscount="cloudDiscount"
          :isAccountant="isAccountant"
          :skpAdd="skpAdd"
          :skpCompanyAdd="skpCompanyAdd"
          :skpAccountantAdd="skpAccountantAdd"
          :program="program"
          :styles="styles"
        ></order-cloud>
      </div>
      <div v-if="currentStep === 3">
        <order-delivery
          :isAccountant="isAccountant"
          :skpAdd="skpAdd"
          :skpAccountantAdd="skpAccountantAdd"
          :styles="styles"
        ></order-delivery>
      </div>
      <div v-if="currentStep === 4">
        <order-summary
          :cloudOptions="filteredCloudOptions"
          :cloudNeverHave="cloudNeverHave"
          :isDiscount622_623="isDiscount622_623"
          :isDiscount656_657="isDiscount656_657"
          :isAccountant="isAccountant"
          :skpCompanyAdd="skpCompanyAdd"
          :skpAccountantAdd="skpAccountantAdd"
          :cloudDiscount="cloudDiscount"
          :skpAdd="skpAdd"
          :program="program"
          :styles="styles"
        ></order-summary>
      </div>
      <div v-if="currentStep === 5">
        <order-submitted></order-submitted>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressSteps from './partials/order/ProgressSteps';
import OrderProducts from './partials/order/OrderProducts';
import OrderCloud from './partials/order/OrderCloud';
import OrderDelivery from './partials/order/OrderDelivery';
import OrderSummary from './partials/order/OrderSummary';
import OrderSubmitted from './partials/order/OrderSubmitted';
import BlockOrder from './partials/order/BlockOrder';
import { mapGetters } from 'vuex';
import { skp_plans_F, skp_plans_B, sam_plans } from './config/cloudPlans';
import moment from 'moment';

export default {
  name: 'Order',
  components: {
    ProgressSteps,
    OrderProducts,
    OrderCloud,
    OrderDelivery,
    OrderSummary,
    OrderSubmitted,
    BlockOrder,
  },
  props: {
    styles: {},
  },
  data() {
    return {
      allCloudOptions: {},
      filteredCloudOptions: {},
      cloudData: {},
      year: process.env.MIX_AKTU_YEAR,
      plan: null,
      cloudNeverHave: null,
      price: null,
    };
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
      licence: 'auth/userLicence',
      currentStep: 'order/currentStep',
      cartProducts: 'order/getCartProducts',
      client: 'auth/client',
      currentCloud: 'order/currentCloud',
      currentOs: 'auth/currentOs',
      discounts: 'order/discounts',
    }),
    isDiscount622_623() {
      return moment().format('M') == 1 && this.cloudNeverHave;
    },
    isDiscount656_657() {
      return typeof this.cloudDiscount === 'object' &&
        this.cloudDiscount !== null
        ? this.cloudDiscount.id === 656 || this.cloudDiscount.id === 657
        : false;
    },
    isAccountant() {
      return (
        (this.client.MDS !== null &&
          this.client.MDS !== '' &&
          this.client.MDS.split('').includes('B')) ||
        this.accountantAdd
      );
    },
    cloudDiscount() {
      return this.discounts.find((discount) => {
        return discount && typeof discount.conditions === 'string'
          ? discount.conditions === 'cloud'
          : false;
      });
    },
    accountantAdd() {
      return (
        this.cartProducts.filter(
          (row) => row.key === 'B1' || row.key === 'B2' || row.key === 'B3'
        ).length > 0
      );
    },
    skpAdd() {
      let product = this.cartProducts.filter(
        (row) =>
          (row.UWAGI === 'N_SKP' && row.key !== 'O') ||
          ((row.key === 'B1' || row.key === 'B2' || row.key === 'B3') &&
            this.program === 'sam')
      );

      return product.length > 0 ? product[0] : null;
    },
    skpCompanyAdd() {
      return this.skpAdd && this.skpAdd.key === 'PODST';
    },
    skpAccountantAdd() {
      return (
        this.skpAdd &&
        (this.skpAdd.key === 'B1' ||
          this.skpAdd.key === 'B2' ||
          this.skpAdd.key === 'B3')
      );
    },
    orderNotAvailable() {
      return (
        process.env.MIX_DEBUG !== 'true' &&
        !(
          localStorage.getItem('staffName') === 'formsoft' &&
          localStorage.getItem('staffId') === '0'
        ) &&
        !(
          this.year + '-01-01' <= moment().format('YYYY-MM-DD') &&
          this.year + '-12-01' > moment().format('YYYY-MM-DD')
        ) &&
        this.licence != 1
      );
    },
  },
  created() {
    this.$store.dispatch('auth/me');
    axios
      .get('/api/getCloudDiscount/' + this.program + '/' + this.licence)
      .then(({ data }) => {
        if (data) {
          this.$store.commit('order/addDiscount', data);
        }
      });
  },
  methods: {
    updateCloudDataByClient(currentPlan) {
      this.plan = currentPlan;
      this.getCloudOptions();
    },
    UpdateCloudNeverHave(cloudNeverHave) {
      this.cloudNeverHave = cloudNeverHave;
    },
    getCloudOptions() {
      axios
        .get('/api/getCloudOptions/' + this.program + '/' + this.licence)
        .then(({ data }) => {
          this.allCloudOptions = data;
          this.filterCloudOptions();
          if (this.plan) {
            let that = this;
            Object.values(this.allCloudOptions).forEach(function (option) {
              if (option.value === that.plan) {
                that.$store.commit('order/setCurrentCloudPrice', option.net);
              }
            });
          } else {
            this.applyDiscount();
          }
        });
    },
    applyDiscount() {
      if (this.cloudDiscount && this.cloudDiscount['percent'] > 0) {
        let that = this;
        Object.values(this.allCloudOptions).forEach(function (option) {
          option.oldNet = option.net;
          option.net =
            option.net - option.net * (that.cloudDiscount['percent'] / 100);
          option.oldGross = option.gross;
          option.gross =
            option.gross - option.gross * (that.cloudDiscount['percent'] / 100);
        });
      }
    },
    filterCloudOptions() {
      let options = [];
      if (
        this.accountantAdd ||
        (this.program === 'skp' && this.isAccountant) ||
        this.skpAccountantAdd
      ) {
        options = this.filterAccountantCloudOptions();
      } else if (
        this.skpCompanyAdd ||
        (this.program === 'skp' && !this.isAccountant)
      ) {
        options = this.filterCompanyCloudOptions();
      } else if (this.program === 'sam') {
        options = this.filterSamCloudOptions();
      }

      this.filteredCloudOptions = options.reduce(
        (i, item) => ({ ...i, [item.value]: item }),
        {}
      );
    },
    filterCompanyCloudOptions() {
      let options = [];

      Object.values(this.allCloudOptions).forEach(function (option) {
        Object.values(skp_plans_F).forEach(function (planId) {
          if (option.value === planId) {
            options.push(option);
          }
        });
      });

      return options;
    },
    filterAccountantCloudOptions() {
      let options = [];

      Object.values(this.allCloudOptions).forEach(function (option) {
        Object.values(skp_plans_B).forEach(function (planId) {
          if (option.value === planId) {
            options.push(option);
          }
        });
      });

      return options;
    },
    filterSamCloudOptions() {
      let options = [];

      Object.values(this.allCloudOptions).forEach(function (option) {
        Object.values(sam_plans).forEach(function (planId) {
          if (option.value === planId) {
            options.push(option);
          }
        });
      });

      return options;
    },
  },
};
</script>

<style scoped></style>
